// extracted by mini-css-extract-plugin
export default {"filterYears":"ExpenseFilterByYear_filterYears__b7sOA","yearsDropdown":"ExpenseFilterByYear_yearsDropdown__eX0Vk","fontSize":"ExpenseFilterByYear_fontSize__t40jH"};